export default __webpack_public_path__ + "static/media/oven2-portrait.8321d556.png";